export default "__VITE_ASSET__976e7e89__"